export default from './post-create-page-header';



// WEBPACK FOOTER //
// ./app/containers/post-create-page-header/index.js